import request from '@/utils/request'
import {
  CreateBundleConditionReq,
  CreateBundleConditionSkuReq,
  GetSingleBatchSettingsReq,
  SingleBatchSettingItem,
  UploadBundleConditionsExcelErrorData,
  UploadBundleConditionsExcelReq,
} from '@/services/outbound/singleBatchSetting/types'

export const getSingleBatchSettings = (params: GetSingleBatchSettingsReq) =>
  request.get<ApiResponseV2<ApiPageResponse<SingleBatchSettingItem>>, GetSingleBatchSettingsReq>('/api/v1/bundle-conditions', params)

export const createBundleCondition = (params: CreateBundleConditionReq) =>
  request.post<ApiResponseV2<null>, CreateBundleConditionReq>('/api/v1/bundle-conditions', params)

export const createBundleConditionSku = (params: CreateBundleConditionSkuReq) =>
  request.post<ApiResponseV2<null>, CreateBundleConditionSkuReq>('/api/v1/bundle-conditions/sku', params)

export const deleteBundleConditions = (params: { ids: number[] }) => request.post<ApiResponseV2<null>>('/api/v1/bundle-conditions/delete', params)

export const updateBundleConditionStatus = (params: { id: number; status: 'ACTIVE' | 'INACTIVE' }) =>
  request.patch<ApiResponseV2<null>, { status: 'ACTIVE' | 'INACTIVE' }>(`/api/v1/bundle-conditions/${params.id}/status`, { status: params.status })

const postBundleConditionsExcel = (url: string, params: UploadBundleConditionsExcelReq) => {
  const formData = new FormData()
  formData.append('file', params.file)
  formData.append('startAt', params.startAt)
  formData.append('endAt', params.endAt)
  if (params.warehouseCode) formData.append('warehouseCode', params.warehouseCode)
  return request.post<ApiResponseV2<UploadBundleConditionsExcelErrorData | null>, FormData>(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const uploadBundleConditionsExcel = (params: UploadBundleConditionsExcelReq) =>
  postBundleConditionsExcel('/api/v1/bundle-conditions/excel', params)

export const uploadBundleConditionsSkuExcel = (params: UploadBundleConditionsExcelReq) =>
  postBundleConditionsExcel('/api/v1/bundle-conditions/sku/excel', params)
